import get from 'lodash/get';

export default function getOr(object, path, defaultValue) {
  const result = get(object, path, defaultValue);

  return result === null ? defaultValue : result;
}
